import React, { JSX } from 'react';

import { borderRadius, Col, Cols, spacing, Text, TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface RadioButtonOption {
  value: string;
  tKey: TKey;
}

interface IProps {
  options: RadioButtonOption[];
  onChange: (value: string) => void;
  selectedValue: string;
}

export const RadioButtonSelector = ({ options, onChange, selectedValue }: IProps): JSX.Element => {
  return (
    <Cols gap={spacing.small} wrap style={{ alignItems: 'center', rowGap: spacing.extraSmall }}>
      {options.map((option) => {
        const isSelected = selectedValue === option.value;
        return (
          <Col
            smallVerticalPadding
            horizontalPadding
            onClick={() => {
              onChange(option.value);
            }}
            style={{
              border: `1px solid ${publicaColors.lightGray}`,
              borderRadius: borderRadius.base,
              backgroundColor: isSelected ? publicaColors.lighterBlue : 'inherit',
              cursor: 'pointer',
            }}
          >
            <Text tKey={option.tKey} singleLineLabel disableSelect small bold={isSelected} />
          </Col>
        );
      })}
    </Cols>
  );
};
